<div class="container my-4">
    <div class="row">
        <div class="col-12 commission_report">
            <div class="title_header_bar">
                Home-Connect Aging Report
            </div>
        </div>
    </div>
    <div class="card card_content">
            <div class="row">
                <div class="col-xl-1"></div>
                <div class="col-xl-10">
                    <div class="row d-flex align-items-center">
                        <div class="col-xl-6 text-right">
                           <mat-label>HC Aged Receivables Report</mat-label>
                        </div>
                        <div class="col-xl-6">
                            <button class="btn btn-secondary"
                                (click)="generateExcel()">
                                Click Here to Download&nbsp;
                                <i class="fa fa-file-excel-o"></i>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="col-xl-1"></div>
            </div>
    </div>
</div>
